import { Autocomplete, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import AutocompleteCreatable from '../../../shared_elements/components/AutocompleteCreatable';
import { AttachementsUpload } from '../../../shared_elements/components';
import { globalGetService, globalPostService, globalPutService } from '../../../utils/globalApiServices';
import { addExpiryAlertApi,  updateExpiryAlertApi } from '../apiService';
import { checkApiStatus } from '../../../utils';
import { enqueueSnackbar } from 'notistack';
import { regexConstants } from '../../../constants/regEx';
import { useDispatch, useSelector } from 'react-redux';
import { setFileUploadDetails } from '../../../shared_elements/actions';
import { formatBytes } from '../../../utils/fileUpload';
import { trackActivity } from '../../../utils/mixpanel';
import LessMoreTextFieldComp from '../../../shared_elements/components/LessMoreTextFieldComp';
import InfoIcon from '@mui/icons-material/Info'

function ExpiryAlertCRU({ modeType, addEditExpiryAlert, onToggleModal, params, getResponseBack, fileUpload, onOpenAttachments }) {
    const dispatch = useDispatch();
    const { storageDetails } = useSelector((state) => state.leases);
    const [loading, setLoading] = useState(false);
    const [expiryAlertdata, setExpiryAlertData] = useState({ ...addEditExpiryAlert?.data, sparta_users: addEditExpiryAlert?.data?.sparta_users?.map(user => user.email), non_sparta_users: addEditExpiryAlert?.data?.non_sparta_users?.map(user => user.email) });
    const [error, setError] = useState({});
    const [users, setUsers] = useState([]);
    const [dropDownLoader, setDropDownLoader] = useState({ constant: false, user: false, currency: false });
    const [moduleOptions, setModuleOptions] = useState([]);
    const [moduleFieldOptions, setModuleFieldOptions] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const existingExpDate = addEditExpiryAlert?.data?.existingExpDate;
    const editingModuleKey = modeType === 'edit' ? addEditExpiryAlert?.data?.module?.key : null;
    const editingFieldName = modeType === 'edit' ? addEditExpiryAlert?.data?.module_fields?.field_name : null;
    const getAvailableFields = (moduleKey, rawFields) => {
        if (!existingExpDate?.length) return rawFields || [];
        const usedByOthers = existingExpDate
            .filter(item => item.key === moduleKey)
            .map(item => item.field_name)
            .filter(name => !(moduleKey === editingModuleKey && name === editingFieldName));
        return (rawFields || []).filter(field => !usedByOthers.includes(field.field_name));
    };
    const viewModeAutocompleteSx = modeType === "view" ? {
        "& .MuiInputBase-input.Mui-disabled": {
            color: "#969696",
            opacity: 1
        },
        "& .MuiChip-root.Mui-disabled": {
            opacity: 1,
            backgroundColor: "#e2e2e2",
            "& .MuiChip-label": { color: "#969696", }
        },
    } : {};

    useEffect(() => {
        getSpartaUserList();
        getExpiryModules();
    }, []);

    const addEditExpiryAlertData = () => {
        let validationInputs = {};
        validationInputs = {
            name: expiryAlertdata?.name ? "" : "Please enter Name",
            frequency_to_notify: expiryAlertdata?.frequency_to_notify ? "" : "Please enter Notify Days",
            features: expiryAlertdata?.module ? "" : "Please select the Features",
            based_on_field: expiryAlertdata?.module_fields ? "" : "Please select the Based On field",
            // sparta_users: expiryAlertdata?.sparta_users?.length>0 ? "" : "Please enter at least one Sparta user"
        };

        if (expiryAlertdata?.module) {
            validationInputs.based_on_field = expiryAlertdata?.module_fields ? "" : "Please select the Based On Field";
        }
        const hasSpartaUsers = expiryAlertdata?.sparta_users?.length > 0;
        const hasNonSpartaUsers = expiryAlertdata?.non_sparta_users?.length > 0;
        if (!hasSpartaUsers && !hasNonSpartaUsers) {
            setLoading(false);
            enqueueSnackbar("Please add Sparta users or Non-Sparta users", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
            return;
        }
        const validEmailSet = new Set(users.map(u => u.email));
        const invalidUsers = expiryAlertdata?.sparta_users.filter(email => !validEmailSet.has(email));
        if (invalidUsers.length) {
            setLoading(false);
            enqueueSnackbar(`The following SPARTA user(s) are invalid: ${invalidUsers.join(", ")}`, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
            return;
        }
        let payload = Object.assign({}, expiryAlertdata);
        payload = { ...payload, }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            if (expiryAlertdata.id) {
                globalPutService(updateExpiryAlertApi({ ...params, slug: expiryAlertdata?.slug }), payload)
                    .then(async (response) => {
                        if (checkApiStatus(response)) {
                            if (uploadedFiles?.length > 0) {
                                fileUpload(expiryAlertdata.slug, 'updated');
                            }
                            onToggleModal();
                            setLoading(false);
                            getResponseBack();
                            trackActivity('Item Edited', { page_title: `Edit Expiry Alert`, success_msg: response?.data?.message, item_id: expiryAlertdata?.id, payload: expiryAlertdata, response: response?.data })
                            enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        } else {
                            setLoading(false);
                            enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } })
                            trackActivity('Item Edited', { page_title: `Edit Expiry Alert`, error_msg: response?.data?.message, item_id: expiryAlertdata?.id, payload: expiryAlertdata, response: response?.data })
                        }
                    })
            } else {
                globalPostService(addExpiryAlertApi({ leaseSlug: params?.leaseSlug }), payload)
                    .then(async (response) => {
                        if (checkApiStatus(response)) {
                            if (uploadedFiles?.length > 0) {
                                fileUpload(response?.data?.data.slug, 'created');
                            }
                            onToggleModal();
                            getResponseBack();
                            setLoading(false);
                            trackActivity('Item Added', { page_title: `Add Expiry Alert`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: expiryAlertdata, response: response?.data })
                            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } })
                        } else {
                            setLoading(false);
                            trackActivity('Item Added', { page_title: `Add Expiry Alert`, error_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: expiryAlertdata, response: response?.data })
                            enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } })
                        }
                    })
            }
        } else {
            setError(validationInputs);
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Expiry Alert`, error_msg: validationInputs, })
        }
    }

    const getSpartaUserList = () => {
        setDropDownLoader(prev => ({ ...prev, user: true }));
        globalGetService('/console/expiry_alert/user_dropdown/')
            .then(response => {
                setDropDownLoader(prev => ({ ...prev, user: false }));
                if (checkApiStatus(response)) {
                    setLoading(false);
                    setUsers(response?.data?.data);
                }
            })
    }

    const handelInputChange = (key, value) => {
        if (key === 'module') {
            setExpiryAlertData({ ...expiryAlertdata, [key]: value, module_fields: null })
            setModuleFieldOptions(value?.expiry_fields);
        }
        else setExpiryAlertData({ ...expiryAlertdata, [key]: value, })
    }

    const onRestErrorKey = (key) => {
        setError((prev) => ({ ...prev, [key]: '' }));
    };

    const getExpiryModules = () => {
        setDropDownLoader(prev => ({ ...prev, constant: true }));
        globalGetService('/alerts/modules/?for_expiry_alert=1')
            .then(response => {
                setDropDownLoader(prev => ({ ...prev, constant: false }));
                if (checkApiStatus(response)) {
                    const modules = response?.data?.data || [];
                    const displayModules = modules.map(module => ({ ...module, expiry_fields: getAvailableFields(module.key, module.expiry_fields) })).filter(module => module.expiry_fields.length > 0);
                    setModuleOptions(displayModules);
                    if (modeType === 'edit' && expiryAlertdata?.module) {
                        const currentModuleData = displayModules.find(m => m.key === expiryAlertdata.module.key);
                        setModuleFieldOptions(currentModuleData?.expiry_fields || []);
                    }
                    setModuleOptions(modules);
                }
            });
    };

    const getValidEmails = (value = []) => {
        if (!Array.isArray(value)) return [];
        return [
            ...new Set(
                value
                    .map(item => item?.label ?? item)
                    .filter(email => regexConstants.email.test(email))
            )
        ];
    };
    const handleFileChange = (files) => {
        setUploadedFiles(files);
        dispatch(setFileUploadDetails({ attachments: files }))
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Expiry Alert`, page_type: page_type, })
    }
    const nonSpartaLength = expiryAlertdata?.non_sparta_users?.length || 0;
    return (
        <>
            <Dialog
                aria-labelledby="customized-dilog-title"
                className="add-lease-dialog"
                maxWidth="md"
                fullWidth
                open={addEditExpiryAlert?.modal}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
                    <Typography className='dialog-header-title'>
                        {modeType === 'add' ? "Add Expiry Alert" : modeType === 'edit' ? 'Edit Expiry Alert' : 'View Expiry Alert'}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id='name'
                                label="Name"
                                value={expiryAlertdata?.name}
                                onChange={(e) => {
                                    regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("name", e.target.value.trimStart()) : e.preventDefault();
                                    setError(prev => ({ ...prev, name: "" }));
                                }}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 100 } }}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                required
                                disabled={modeType === "view"}
                                helperText={error.name}
                                error={error.name}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id='frequency_to_notify'
                                label={
                                    <span>
                                        Notify Days
                                        <Tooltip placement='right' title={<span>Specifies the advance notice period (in days) for triggering an automated email alert before the scheduled due date</span>} arrow>
                                            <InfoIcon fontSize='small' color='primary' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'medium' }} />
                                        </Tooltip>
                                    </span>
                                }
                                value={expiryAlertdata?.frequency_to_notify || ""}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\s+/g, "");
                                    if (/^[0-9,]*$/.test(value)) {
                                        handelInputChange("frequency_to_notify", value);
                                        setError(prev => ({ ...prev, frequency_to_notify: "" }));
                                    }
                                }}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 255 } }}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                disabled={modeType === "view"}
                                required
                                helperText={error.frequency_to_notify}
                                error={error.frequency_to_notify}
                                placeholder='Ex: 90,60,30'
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disableClearable
                                disabled={modeType === "view"}
                                options={moduleOptions || []}
                                loading={dropDownLoader?.constant}
                                getOptionLabel={(option) => option?.name || ""}
                                value={expiryAlertdata?.module || null}
                                onChange={(e, value) => {
                                    handelInputChange("module", value);
                                    onRestErrorKey("features");
                                    onRestErrorKey("based_on_field");
                                }}
                                onFocus={() => { onRestErrorKey("module"); }}
                                size="small"
                                noOptionsText={dropDownLoader?.constant ? "Loading..." : "No options"}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Features"
                                        variant="outlined"
                                        size="small"
                                        margin="normal"
                                        required
                                        helperText={error.features}
                                        error={error.features}
                                        slotProps={{
                                            input: {
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {dropDownLoader?.constant && (
                                                            <CircularProgress color="inherit" size={18} />
                                                        )}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            },
                                            inputLabel: { shrink: true, },
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disableClearable
                                filterSelectedOptions
                                disabled={modeType === "view"}
                                options={moduleFieldOptions || []}
                                getOptionLabel={(option) => option?.field_name || ""}
                                isOptionEqualToValue={(option, value) => option?.field_name === value?.field_name}
                                value={expiryAlertdata?.module_fields || null}
                                onChange={(e, value) => { handelInputChange("module_fields", value); onRestErrorKey("based_on_field"); }}
                                size="small"
                                onFocus={() => { onRestErrorKey("module_fields") }}
                                loading={dropDownLoader?.constant}
                                noOptionsText={dropDownLoader?.constant ? "Loading..." : "No options"}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Based On Fields"
                                        variant="outlined"
                                        size="small"
                                        margin="normal"
                                        required={!!expiryAlertdata?.module}
                                        helperText={error.based_on_field}
                                        error={!!error.based_on_field}
                                        slotProps={{
                                            input: {
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {dropDownLoader?.constant && (
                                                            <CircularProgress color="inherit" size={18} />
                                                        )}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            },
                                            inputLabel: { shrink: true, },
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disableClearable
                                disabled={modeType === "view"}
                                options={[
                                    { label: "Active", value: true },
                                    { label: "Inactive", value: false }
                                ]}
                                getOptionLabel={(option) => option?.label || ""}
                                size="small"
                                value={{
                                    label: (expiryAlertdata?.status ?? true) ? "Active" : "Inactive",
                                    value: expiryAlertdata?.status ?? true
                                }}
                                onChange={(e, value) => handelInputChange("status", value?.value)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Status"
                                        size="small"
                                        margin="normal"
                                        required
                                        InputLabelProps={{ shrink: true }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <Autocomplete
                                multiple
                                disablePortal
                                disableClearable
                                disabled={modeType === "view"}
                                options={users ? users.map((user) => user?.email).filter(Boolean) : []}
                                value={expiryAlertdata?.sparta_users || []}
                                filterSelectedOptions
                                loading={dropDownLoader?.user}
                                onChange={(e, newValue) => {
                                    handelInputChange("sparta_users", newValue);
                                    if (newValue?.length === 0 && nonSpartaLength === 0) {
                                        onRestErrorKey("sparta_users");
                                    }
                                }}
                                noOptionsText={dropDownLoader?.user ? "Loading..." : "No Option Available"}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="SPARTA User"
                                        size="small"
                                        placeholder={(expiryAlertdata?.sparta_users?.length ?? 0) > 0 ? "" : "Select User(s)"}
                                        sx={viewModeAutocompleteSx}
                                        slotProps={{ inputLabel: { shrink: true, }, input: { ...params?.InputProps, endAdornment: ( <> {modeType !== "view" && dropDownLoader?.user && <CircularProgress color="inherit" size={20} />} {params?.InputProps?.endAdornment} </> ), }, }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid size={{ md: 12, xs: 12 }} sx={viewModeAutocompleteSx}>
                            <AutocompleteCreatable
                                label="Non-SPARTA User"
                                multiple
                                disableClearable
                                isDisabled={modeType === "view"}
                                options={[]}
                                value={expiryAlertdata?.non_sparta_users || []}
                                onFieldChange={(e, key, newValue) => {
                                    const validEmails = getValidEmails(newValue);
                                    handelInputChange('non_sparta_users', validEmails);
                                    const spartaLength = expiryAlertdata?.sparta_users?.length || 0;
                                    if (newValue.length === 0 && spartaLength === 0) {
                                        onRestErrorKey("sparta_users");
                                    }
                                }}
                            />
                        </Grid>
                        {modeType === "view" ? <Grid item size={{ md: 12, xs: 12 }}>
                            <LessMoreTextFieldComp label='Description' value={expiryAlertdata?.description} />
                        </Grid> :
                            <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    id='description'
                                    label="Description"
                                    value={expiryAlertdata?.description}
                                    onChange={(e) => { handelInputChange("description", e.target.value) }}
                                    variant='outlined'
                                    size='small'
                                    margin='normal'
                                    slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 255} }}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    fullWidth
                                    rows={3}
                                    multiline
                                    disabled={modeType === "view"}
                                />
                            </Grid>}
                        <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 3 }}>
                            <Box className="responsive-buttons">
                                {expiryAlertdata?.id && expiryAlertdata?.attachments?.length ?
                                    <Button onClick={() => { onOpenAttachments(); handleItemClicked('ViewAttachments Button') }} size='small' variant='outlined' color="primary" sx={{ marginBottom: '10px' }} >
                                        ({expiryAlertdata?.attachments?.length}) Attachment(s)
                                    </Button> : <Button color='primary' variant='outlined' size='small' sx={{ marginBottom: '10px' }}>Attachment(s)</Button>
                                }
                                <Button className='available-space-btn' disableRipple size='small' variant='outlined' color='primary'>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
                            </Box>
                            {modeType === "view" ? null : <AttachementsUpload onFileChange={handleFileChange} attachments={expiryAlertdata?.attachments} remainingStorage={storageDetails?.remaining_storage} />}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-action'>
                    <Button className='cancel-btn' variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked(modeType === "view" ? "Close" : "Cancel") }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null : <Button variant='contained' size='small' className='btn-primary' disabled={modeType === "view"} onClick={() => { addEditExpiryAlertData(); handleItemClicked('Save Button') }}>{loading ? <CircularProgress color='inherit' size={24} /> : "Save"}</Button>}
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ExpiryAlertCRU;
